import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "modalRef",
  class: "modal-content"
}
const _hoisted_2 = { class: "folder-section" }
const _hoisted_3 = { class: "folder-section-create" }
const _hoisted_4 = { class: "search" }
const _hoisted_5 = { class: "folder-section-folders" }
const _hoisted_6 = { class: "folder-section-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_modal_header = _resolveComponent("app-modal-header")!
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_folder_card = _resolveComponent("app-folder-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_modal_header, { onClose: _ctx.close }, null, 8, ["onClose"]),
    _createElementVNode("section", _hoisted_2, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_app_loader, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_app_input, {
            modelValue: _ctx.search,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
            placeholder: "search",
            icon: ['fas', 'search'],
            "is-label": false
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_app_button, {
          icon: ['fas', 'plus'],
          severity: "info",
          onClick: _ctx.openCreateFolderModal
        }, null, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folders, (c) => {
          return (_openBlock(), _createBlock(_component_app_folder_card, {
            key: c.id,
            folder: c,
            "is-selected": _ctx.selectedFolder?.id === c?.id,
            onSelected: _ctx.selected
          }, null, 8, ["folder", "is-selected", "onSelected"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: "btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.choose && _ctx.choose(...args)))
        }, [
          _createVNode(_component_app_button, {
            disabled: !_ctx.selectedFolder,
            title: "choose",
            severity: "warning"
          }, null, 8, ["disabled"])
        ])
      ])
    ])
  ], 512))
}